module.exports = __webpack_public_path__ + "static/img/menu-down-dark.49107b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/menu-down-dark.png
// module id = SLgj
// module chunks = 1